import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { sendCode } from 'services/auth'
import posthog from 'posthog-js'
interface ISendCodePayload {
    phone_number: string
}
const UseSendCode = (
    setIsSubmit: React.Dispatch<React.SetStateAction<boolean>>
) => {
    const navigate = useNavigate()
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: ISendCodePayload) => {
            return sendCode(payload)
        },
        onSuccess: (_, variables) => {
            posthog.capture('otp_requested', { is_resend: false })
            toast.success('کد با موفقیت ارسال شد')
            navigate('/auth/confirmation', {
                state: {
                    mobile: variables?.phone_number,
                },
            })
        },
        onError: (error: any) => {
            posthog.capture('otp_request_failed', {
                status: error?.response?.status,
            })
            toast.error('خطایی رخ داده!')
            setIsSubmit(false)
        },
    })

    return { isLoading, mutate }
}

export default UseSendCode
